import { SJDatabase } from '@/shared/lib/sj-orm';
import { PrivateDocumentDto } from '@/shared/lib/sj-orm/models/document/private.document.dto';

type Props = {
  doc: PrivateDocumentDto;
  sjDb: SJDatabase;
  emptyText?: string;
};

export const renderSignatories = ({ doc, sjDb, emptyText = '-' }: Props) => {
  if (!doc.signatories || !doc.signatories.length) return emptyText;

  const data = doc.signatories.map(
    (id) => sjDb.collections.personalIdentifiersDocuments?.findById(id),
  );

  if (!data) return emptyText;

  return data.map((personalId) => personalId?.name ?? personalId?.shortname).join(', ');
};
